import { PaginationFilterRequest, StatusInfoModel } from './core.model';

export interface Link {
    id: number;
    name: string;
    linkPath: string;
    type: LinkTypeEnum;
    runningClubId?: number;
    encyclopediaItemId?: number;
}

export interface UpsertLink {
    id?: number;
    name?: string;
    linkPath?: string;
    type?: LinkTypeEnum;
    runningClubId?: number;
    encyclopediaItemId?: number;
}

export class LinksPaginationFilterRequest extends PaginationFilterRequest {
    runningClubId?: number;
    encyclopediaItemId?: number;
    type?: LinkTypeEnum;
}


export enum LinkTypeEnum
{
    Others = 1,
    Website = 2,
    Facebook = 3,
    Instagram = 4,
    Strava = 5,
}

export const LinkTypeInfoMap: Record<LinkTypeEnum, StatusInfoModel> = {
  [LinkTypeEnum.Others]: {value: LinkTypeEnum.Others, label: "Others", color: 'cyan'},
  [LinkTypeEnum.Website]: {value: LinkTypeEnum.Website, label: "Website", color: 'cyan'},
  [LinkTypeEnum.Facebook]: {value: LinkTypeEnum.Facebook, label: "Facebook", color: 'blue'},
  [LinkTypeEnum.Instagram]: {value: LinkTypeEnum.Instagram, label: "Instagram", color: 'violet'},
  [LinkTypeEnum.Strava]: {value: LinkTypeEnum.Strava, label: "Strava", color: 'orange'},
};
